export default __webpack_public_path__ + "static/media/position.6b2d5340.svg";